import getAxiosInstance from '../js/axios/axios';

const otm = getAxiosInstance('otm');

export const getExamRoomUser = userId =>
  otm.get(`/uauth/user/${userId}/detail`, {retry: true});

export const updateUserLastLoginIp = userId => {
  return otm.patch(
    `uauth/user/${userId}/ip`,
    {
      status: 'LOGIN',
    },
    {retry: true, retryCount: 1},
  );
};

export const userStatusCheck = userId => {
  return otm.get(`uauth/user/${userId}/status`);
};

export const getTimestamp = () => {
  return otm.get('/timestamp');
};
